import React from "react";
import ViewScroller from "../Components/Common/ViewScroller/ViewScroller";
import RightModal from "../Components/Modals/RightModal/RightModal";
import TransporterViewContent from "../Components/Transporter";

const TransporterView = () => {
  console.log("hello");
  return (
    <ViewScroller>
      <div className="w100 d-flex flex-column gap-4 h-100">
        <TransporterViewContent />
        <RightModal width={70} />
      </div>
    </ViewScroller>
  );
};

export default TransporterView;
